import { useEffect, useRef, useState } from "react"
import {
  cohortIcon,
  helpIcon,
  homeIcon,
  injectionIcon,
  logoIcon,
  logoMarkIcon,
  menuIcon,
  moreIcon,
  patientsIcon,
  reportsIcon,
  // reportsIcon,
  settingsIcon,
  testsIcon,
} from "../../icons"
import "./sidebar.component.css"
import { logout } from "../../firebase"
import { Link, useLocation, useNavigate } from "react-router-dom"
import useClickOutside from "../../hooks/useClickOutside"
import { gsap } from "gsap"

const SidebarComponent = (props) => {
  const { user, userMeta, role } = props
  const location = useLocation()
  const navigate = useNavigate()
  const [showUserMenu, setShowUserMenu] = useState()
  const [collapsed, setCollapsed] = useState()

  const menuRef = useRef()
  useClickOutside(menuRef, () => setShowUserMenu(false))

  const handleLogout = async () => {
    try {
      await logout()
      navigate("/login", { replace: true })
    } catch {
      // todo handle error
    }
  }

  const handleNav = (path) => {
    navigate(path)
  }

  // Animate
  useEffect(() => {
    gsap.fromTo(
      ".cb-logo-container svg",
      {
        yPercent: -40,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power3.inOut",
      }
    )

    gsap.fromTo(
      ".cb-sidebar ul li",
      {
        yPercent: -40,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.2,
        delay: 0.1,
        stagger: 0.05,
        ease: "power3.inOut",
      }
    )

    gsap.fromTo(
      ".cb-sidebar-auth",
      {
        yPercent: 40,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.7,
        delay: 0.4,
        ease: "power3.inOut",
      }
    )
  }, [])

  return (
    <div className={["cb-sidebar", collapsed ? "collapsed" : ""].join(" ")}>
      <header>
        <div className="cb-logo-container">
          <button onClick={() => setCollapsed(!collapsed)}>{menuIcon}</button>
          {collapsed ? logoMarkIcon : logoIcon}
        </div>
        <ul>
          <li
            className={location.pathname === "/dashboard" ? "selected" : ""}
            onClick={() => handleNav("/dashboard")}
          >
            {homeIcon} <span>Home</span>
          </li>
          {/* <li
            className={location.pathname === "/reports" ? "selected" : ""}
            onClick={() => handleNav("/reports")}
          >
            {reportsIcon} Reports
          </li> */}
          <li
            className={
              location.pathname.indexOf("/tests") > -1 ? "selected" : ""
            }
            onClick={() => handleNav("/tests")}
          >
            {testsIcon} <span>Tests</span>
          </li>
          <li
            className={
              location.pathname === "/cohort-analysis" ? "selected" : ""
            }
            onClick={() => handleNav("/cohort-analysis")}
          >
            {cohortIcon} <span>Cohort Analysis</span>
          </li>
          <li
            className={location.pathname === "/patients" ? "selected" : ""}
            onClick={() => handleNav("/patients")}
          >
            {patientsIcon} <span>Patients</span>
          </li>
          <li
            className={location.pathname === "/trials" ? "selected" : ""}
            onClick={() => handleNav("/trials")}
          >
            {reportsIcon} <span>Clinical Trials</span>
          </li>
          <li
            className={location.pathname === "/injections" ? "selected" : ""}
            // onClick={() => handleNav("/patients")}
          >
            {injectionIcon} <span>Injections</span>
          </li>
        </ul>
        <ul>
          <li
            className={location.pathname === "/settings" ? "selected" : ""}
            onClick={() => handleNav("/settings")}
          >
            {settingsIcon} <span>Settings</span>
          </li>
          <li
            className={location.pathname === "/help" ? "selected" : ""}
            // onClick={() => handleNav("/help")}
          >
            {helpIcon} <span>Help</span>
          </li>
          {/* {role === "admin" && (
            <li
              className={location.pathname === "/labs" ? "selected" : ""}
              onClick={() => handleNav("/labs")}
            >
              <span className="icon-package" /> Labs
            </li>
          )}
          {role === "admin" && (
            <li
              className={location.pathname === "/devices" ? "selected" : ""}
              onClick={() => handleNav("/devices")}
            >
              <span className="icon-cpu" /> Devices
            </li>
          )}
          {role === "admin" && (
            <li
              className={location.pathname === "/operators" ? "selected" : ""}
              onClick={() => handleNav("/operators")}
            >
              <span className="icon-user" /> Operators
            </li>
          )}
          <li
            className={location.pathname === "/patients" ? "selected" : ""}
            onClick={() => handleNav("/patients")}
          >
            <span className="icon-database" /> Patients
          </li>
          <li
            className={location.pathname === "/tests" ? "selected" : ""}
            onClick={() => handleNav("/tests")}
          >
            <span className="icon-clipboard" /> Tests
          </li> */}
        </ul>
      </header>
      <div className="cb-sidebar-auth">
        {showUserMenu && (
          <div className="cb-sidebar-user-menu" ref={menuRef}>
            <h6>{userMeta?.fullName || user.email}</h6>
            {role && <span className={`cb-role-tag role-${role}`}>{role}</span>}
            <Link
              to="/settings"
              className="cb-user-menu-btn"
              onClick={() => setShowUserMenu(false)}
            >
              <span className="icon-sliders" /> Settings
            </Link>
            <button onClick={handleLogout} className="cb-user-menu-btn">
              <span className="icon-log-in" /> Log Out
            </button>
          </div>
        )}
        <div className="cb-sidebar-user-meta">
          <div className="cb-user-avatar">
            {userMeta?.fullName[0] || user.email[0]}
          </div>
          <div className="cb-user-name">
            {userMeta?.fullName || user.email}
            <br />
            <strong>{role}</strong>
          </div>
          <button
            className="cb-sidebar-user-btn"
            onClick={() => setShowUserMenu(true)}
          >
            {moreIcon}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SidebarComponent
